import React, { useEffect, useState } from 'react'
import { Btn, CustomDropdown, CustomModal } from '../../../../../components'
import { CONFIG_FIELD_LABELS, INTEGRATION_PARTNERS, partnerLabel } from './integrationPartners'

// Cria uma integração (escolhendo o parceiro) ou edita a configuração de uma existente.
// Os campos mudam conforme o parceiro; o backend valida tudo de novo ao salvar.
export default function IntegrationFormModal({
  show,
  integration,
  availablePartners,
  options,
  onSave,
  onClose,
}) {
  const [partner, setPartner] = useState(null)
  const [values, setValues] = useState({})

  useEffect(() => {
    if (!show) return
    if (integration) {
      setPartner(INTEGRATION_PARTNERS.find(p => p.value === integration.partner) || null)
      setValues(
        Object.keys(integration.config).reduce((acc, field) => {
          const option = (options[field] || []).find(o => o.id === integration.config[field])
          return option ? { ...acc, [field]: option } : acc
        }, {}),
      )
    } else {
      setPartner(availablePartners.length === 1 ? availablePartners[0] : null)
      setValues({})
    }
    // Reinicia só ao abrir: options e availablePartners mudam a cada recarga da lista
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, integration])

  const fields = partner ? partner.fields : []
  const complete = partner && fields.every(field => values[field])

  const onSaveClicked = () => {
    const config = fields.reduce((acc, field) => ({ ...acc, [field]: values[field].id }), {})
    onSave(integration, partner.value, config)
  }

  return (
    <CustomModal
      header={
        integration ? `Editar integração ${partnerLabel(integration.partner)}` : 'Nova integração'
      }
      isVisible={show}
      onClose={onClose}
      width="560px"
    >
      <div className="p-grid">
        <div className="p-col-12">
          <CustomDropdown
            label="Parceiro"
            optionLabel="label"
            options={integration ? [partner].filter(Boolean) : availablePartners}
            value={partner}
            disabled={!!integration}
            onChange={value => {
              setPartner(value)
              setValues({})
            }}
            appendTo={document.body}
          />
        </div>
        {fields.map(field => (
          <div className="p-col-12" key={field}>
            <CustomDropdown
              label={CONFIG_FIELD_LABELS[field]}
              optionLabel="name"
              options={options[field] || []}
              value={values[field] || null}
              filter
              onChange={value => setValues(v => ({ ...v, [field]: value }))}
              appendTo={document.body}
            />
          </div>
        ))}
        <div className="p-col-12" style={{ marginTop: 10 }}>
          <Btn onClick={onSaveClicked} disabled={!complete}>
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}
